import React, {useState, useEffect, FormEvent} from 'react';
import AdminHeader from '../../Components/AdminHeader/AdminHeader';
import AdminNav from '../../Components/AdminNav/AdminNav';
import 'react-quill/dist/quill.snow.css';
import { useLocation, useNavigate } from 'react-router-dom'; // Add useNavigate
import { editPartnershipText } from '../../actions/BusinessPages';

function EditPartnershipText() {
    const ReactQuill = require('react-quill');
    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'align': [] }],
            ['link', 'image'],
            ['clean'],
        ],
    };
    const location = useLocation();

    const navigate = useNavigate();

    if (location === null || location.state === null || location.state.user === null) {
        navigate('/login');
    }
    const [isCollapsed, setIsCollapsed] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);


    const user = location.state.user;
    const partnership = location.state.partnership;

    const [text, setText] = useState(partnership.right_text);

    const saveText = async(e: FormEvent) => {
        e.preventDefault();
        setIsLoading(true);
        setError(null);

        try {
            const response = await editPartnershipText({
                id: partnership.id,
                text: text
            });

            // Redirect to BusinessPartners page with user data
            navigate('/dashboard/business/partnership', {
                state: { user }
            });

        } catch (err) {
            setError(err instanceof Error ? err.message : 'An error occurred while saving');
            console.error('Error saving partnership text:', err);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div>
            <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user} />
            <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user} />

            <div className={`main-admin-page ${isCollapsed ? 'collapsed' : 'expanded'}`}>
                <div className="main-admin-page-inner">
                    <div>

                    </div>
                    <ReactQuill
                        id="section1Right"
                        value={text}
                        onChange={setText}
                        modules={modules}
                        style={{ minHeight: '200px', marginBottom: '50px', height: '200px' }}
                    />
                </div>

                {error && (
                    <div style={{ color: 'red', marginTop: '10px' }}>
                        {error}
                    </div>
                )}

                <div style={{ marginTop: '30px' }}>
                    <button
                        onClick={saveText}
                        style={{ padding: '10px 20px', fontSize: '16px' }}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Saving...' : 'Save Changes'}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default EditPartnershipText;
